var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1994 6.00005L5.96973 10.3635C5.93491 10.3987 5.90738 10.4405 5.88873 10.4864C5.87009 10.5323 5.8607 10.5815 5.86111 10.631C5.86152 10.6806 5.87172 10.7296 5.89112 10.7752C5.91052 10.8208 5.93874 10.8621 5.97414 10.8967C6.00954 10.9313 6.05142 10.9585 6.09736 10.9767C6.14329 10.9949 6.19238 11.0038 6.24176 11.0029C6.29114 11.0019 6.33985 10.9912 6.38506 10.9712C6.43028 10.9512 6.47109 10.9225 6.50516 10.8865L10.9878 6.26155C11.0557 6.19154 11.0936 6.09772 11.0936 6.00005C11.0936 5.90237 11.0557 5.80855 10.9878 5.73855L6.50516 1.11355C6.47109 1.07764 6.43028 1.04887 6.38506 1.02891C6.33985 1.00894 6.29114 0.998175 6.24176 0.997231C6.19238 0.996286 6.14329 1.00518 6.09736 1.02341C6.05142 1.04163 6.00954 1.06882 5.97414 1.1034C5.93874 1.13797 5.91052 1.17926 5.89112 1.22486C5.87172 1.27046 5.86152 1.31946 5.86111 1.36905C5.8607 1.41863 5.87009 1.4678 5.88873 1.51372C5.90738 1.55963 5.93491 1.60138 5.96973 1.63655L10.1994 6.00005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.5694b01edbce9ec8b2d77a8f0bd75d91.svg";
export { ForwardRef as ReactComponent };